// noinspection NpmUsedModulesInstalled
import moment from "moment";

// noinspection JSUnusedLocalSymbols
export function filter_moment(date) {
    if (!date) return "";
    let date_obj = moment(date, "YYYY/MM/DD");
    if (!date_obj.isValid()) {
        date_obj = moment(date);
    }
    return date_obj.format("DD/MM/YYYY");
}

export function filter_moment_it(date) {
    if (!date) return "";
    let date_obj = moment(date, "DD/MM/YYYY");
    if (!date_obj.isValid()) {
        date_obj = moment(date);
    }
    return date_obj.format("DD/MM/YYYY");
}

export function filter_euro_func(value) {
    const f = new Intl.NumberFormat("it-IT", {
        style: "currency",
        currency: "EUR",
    });
    return f.format(value);
}

